/**
 * 用户管理
 */

export default [
  {
    path: 'emp/manage',
    name: '员工管理',
    component: () => import (`@/views/emp/index.vue`),
  },
  {
    path: 'emp/batchParent',
    name: '批量导入',
    component: () => import ( `@/views/emp/batch/batchParent`),
  },
];

